var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteResolved = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "-290 382 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-283.987 412h18.708l1.871-20.578h-22.449zm13.097-26.191v-3.741h-7.483v3.741h-9.354v5.613l1.871-1.871h22.451l1.87 1.871v-5.613zm-1.872 0h-3.741v-1.871h3.741z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-268.597 410.363h-12.211a2.34 2.34 0 0 1-2.342-2.342v-12.463a2.34 2.34 0 0 1 2.342-2.342h12.211a2.34 2.34 0 0 1 2.342 2.342v12.463a2.343 2.343 0 0 1-2.342 2.342z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269.391 406.928h-1.5l-3.752-3.566-3.705 3.566h-1.547v-1.445l3.705-3.61-3.705-3.566v-1.49h1.547l3.705 3.566 3.752-3.566h1.5v1.49l-3.705 3.566 3.705 3.565z",
    style: {
      fill: "#f40606"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteResolved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deleteResolved.svg";